import React from 'react';
import { connect } from 'react-redux';

import ListPage from '@/src/shared/components/ListPage';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { COMPLIANCE_ACCESS } from '@/src/shared/constants';
import useListSearch from '@/src/shared/hooks/useListSearch';

const LawsAndEnforcementProceduresGuide = () => {
  const [loading, results] = useListSearch({
    pubCode: 11,
    yearsBack: 5,
  });

  return (
    <ListPage
      title="Automobile Insurance Laws and Enforcement Procedures Guide"
      heroContent={<p>Documents from the last 5 years</p>}
      results={results}
      loading={loading}
    />
  );
};

export default connect(mapStateToProps)(
  withMembershipAccessWrap(
    LawsAndEnforcementProceduresGuide,
    COMPLIANCE_ACCESS.AUTO_INSURANCE_COMPLIANCE
  )
);
